import { combineReducers } from "redux-immutable";

import ClassLeaderboardsStateSlice from "../models/ClassLeaderboardsStateSlice";
import classLeaderboardsHistoryReducer from "./state/classLeaderboardsHistory";
import classLeaderboardsMetaReducer from "./state/meta";

export default combineReducers(
  {
    history: classLeaderboardsHistoryReducer,
    meta: classLeaderboardsMetaReducer
  },
  () => new ClassLeaderboardsStateSlice() as any
);
